import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef } from '@angular/material/dialog';
import { topazDefaultDialogOptions } from '@pearsonvue/topaz-angular-ui';
@Component({
  selector: 'app-user-payment-modal',
  standalone: false,
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: topazDefaultDialogOptions
    },
  ],
  templateUrl: './user-payment-modal.component.html',
  styleUrl: './user-payment-modal.component.scss'
})
export class UserPaymentModalComponent {

  constructor (
    public dialogRef: MatDialogRef<UserPaymentModalComponent>,
     @Inject(MAT_DIALOG_DATA) public data : any,
     ){}

  close(data : any): void {
    this.dialogRef.close(data);
    }
}
